import React from 'react'
import request from 'superagent';
import * as Categories from '../constants/Categories'
import {URL_RISKLEVEL} from "../constants/Url";
import {timeoutRedirect} from './Util'
import {Link} from "react-router-dom";
// import TagManager from 'react-gtm-module'
// import {getTagManagerArgs} from './Util';

export default class Risklevel extends React.Component{

  constructor(props) {
    super(props)
    this.state = {
      categories: categories[0],
      results: []
    }
  }

  handleClickOpen(unit_id){
    const { handleModalOpen } = this.props
    handleModalOpen(unit_id)
  }

  handleClickClose(){
    const { handleModalClose } = this.props
    handleModalClose()
  }

  componentWillMount() {
    this.selectCategory(this.state.categories);
  }

  selectCategory(category) {
    request
      .get(URL_RISKLEVEL(this.props.access_token, this.props.gender, this.props.kit, category.categories))
      .set('Content-Type', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log('error')
        }

        if (!res || !res.body.result) {
          timeoutRedirect()
        }

        this.setState({
          results: res.body.result,
          category: category.categories,
          category_id: category.id
        })
      })
  }

  render(){
    // TagManager.initialize(getTagManagerArgs('/risk_level'));

    const {results, category_id} = this.state;

    return(

    <div className="wrap">

      <div className="titlearea">
        <h2>疾患リスクレベル一覧</h2>
        {/*<p className="printbtn">印刷する</p>*/}
      </div>

      <div className="category_icon">
        <ul>
          {categories.map(c =>
            (
              <li key={c.id} className={category_id === c.id ? "active" : ""}>
                <p className="icon" onClick={this.selectCategory.bind(this, c)}><img src={c.icon} alt={c.name}/><span>{c.name}</span></p>
              </li>
            )
          )}
        </ul>
      </div>

      <div className="summary_table">
        <div className="inddata">
          <table>
            <tbody>

              <tr>
                <td className="top_riskrevel color_high">高い</td>
                <td className="top_riskrevel_list color_high">
                  <ul>
                  {results.map(data => {
                    return data.level_type === 5 && <li key={data.unit.id}><Link  to={{
                      pathname: "/detail",
                      state: { referer: "/risklevel" }
                    }} onClick={this.handleClickOpen.bind(this, data.unit.id)}>{data.unit.name}</Link></li>
                  })}
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="top_riskrevel color_high_mid">やや高い</td>
                <td className="top_riskrevel_list color_high_mid">
                  <ul>
                  {results.map(data => {
                    return data.level_type === 4 && <li key={data.unit.id}><Link  to={{
                      pathname: "/detail",
                      state: { referer: "/risklevel" }
                    }} onClick={this.handleClickOpen.bind(this, data.unit.id)}>{data.unit.name}</Link></li>
                  })}
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="top_riskrevel color_mid">標準</td>
                <td className="top_riskrevel_list color_mid">
                  <ul>
                  {results.map(data => {
                    return data.level_type === 3 && <li key={data.unit.id}><Link  to={{
                      pathname: "/detail",
                      state: { referer: "/risklevel" }
                    }} onClick={this.handleClickOpen.bind(this, data.unit.id)}>{data.unit.name}</Link></li>
                  })}
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="top_riskrevel color_low_mid">やや低い</td>
                <td className="top_riskrevel_list color_low_mid">
                  <ul>
                  {results.map(data => {
                    return data.level_type === 2 && <li key={data.unit.id}><Link  to={{
                      pathname: "/detail",
                      state: { referer: "/risklevel" }
                    }} onClick={this.handleClickOpen.bind(this, data.unit.id)}>{data.unit.name}</Link></li>
                  })}
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="top_riskrevel color_low">低い</td>
                <td className="top_riskrevel_list color_low">
                  <ul>
                  {results.map(data => {
                    return data.level_type === 1 && <li key={data.unit.id}><Link  to={{
                      pathname: "/detail",
                      state: { referer: "/risklevel" }
                    }} onClick={this.handleClickOpen.bind(this, data.unit.id)}>{data.unit.name}</Link></li>
                  })}
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    )
  }
}
const categories = [
  {id: 1, icon: 'image/icon/1.png', name: '全て', categories: Categories.DiseaseAll},
  {id: 2, icon: 'image/icon/2.png', name: '感染症', categories: Categories.DiseaseInfections},
  {id: 3, icon: 'image/icon/3.png', name: '性別', categories: Categories.DiseaseGender},
  {id: 4, icon: 'image/icon/4.png', name: '循環器', categories: Categories.DiseaseCirculatory},
  {id: 5, icon: 'image/icon/5.png', name: '呼吸器', categories: Categories.DiseaseRespiratory},
  {id: 6, icon: 'image/icon/6.png', name: '消化器', categories: Categories.DiseaseDigestive},
  {id: 7, icon: 'image/icon/7.png', name: '神経系', categories: Categories.DiseaseNeurological},
  {id: 8, icon: 'image/icon/8.png', name: '内分泌', categories: Categories.DiseaseEndocrineGlands},
  {id: 9, icon: 'image/icon/9.png', name: '泌尿器', categories: Categories.DiseaseUrinary},
  {id: 10, icon: 'image/icon/10.png', name: '骨・関節・皮膚', categories: Categories.DiseaseOsteoSkin},
  {id: 11, icon: 'image/icon/11.png', name: '血液・免疫', categories: Categories.DiseasebloodImmunity},
  {id: 12, icon: 'image/icon/12.png', name: '目・耳・鼻・口', categories: Categories.DiseaseEyeEarNoseOral},
  {id: 13, icon: 'image/icon/13.png', name: 'その他', categories: Categories.DiseaseOthers},
];



// WEBPACK FOOTER //
// ./src/components/Risklevel.js